/**
 * Common masters on the generic drawer that follow the managed-master rules:
 * list toggle owns status, code auto-generated from name, unique sequential sort order,
 * description rejects repeated characters / words.
 */
export const COMMON_MANAGED_MASTER_TYPES = new Set<string>(['taxes', 'units', 'rejection_reasons', 'delivery_modes', 'payment_methods', 'payout_cycles']);

/** Common masters whose display name allows letters, spaces, apostrophes and hyphens only. */
export const COMMON_LETTER_ONLY_NAME_TYPES = new Set<string>(['rejection_reasons', 'delivery_modes', 'payment_methods', 'payout_cycles']);
